import { readPersistedOrgCode } from '../taskpane/utils/org-code-field.util';
import { addinOrganisationContext } from './organisation-context.store';

/**
 * Org the add-in is operating in.
 * Selected managed organisation when the user has chosen one, otherwise the Keycloak org code.
 */
export function resolveAddinOperatingOrgCode(): string {
    return (
        addinOrganisationContext.selectedOrganisationCode() ||
        addinOrganisationContext.storedOrganisationCode() ||
        readPersistedOrgCode()
    );
}

/** Label for the main card title when connected. */
export function getOperatingOrgCodeForTitle(): string {
    const code = resolveAddinOperatingOrgCode();
    return code !== '' ? code : '—';
}
